<template>
  <div>
    <div class="container-fluid container-header">
      <div class="app container-xl app-container">
        <div v-on:click="btnFechar()" class="btn-fechar"><i class="bi bi-chevron-left"></i></div>
        <p class="">{{this.titulo}}</p>
      </div>
    </div>
    <Modal
        modal-id="modalfechar"
        :show-close-button="false"
        title="Quer sair da biometria?"
        text="Você ainda não terminou de confirmar sua identidade e suas informações ainda não estão salvas"
        button-close-text="voltar"
        button-confirm-text="sair"
        v-bind:callback-confirm-button="sairDoApp"
        v-bind:callback-close-button="fecharModal"
    ></Modal>
  </div>

</template>

<script>
import Modal from "./Modal";
import DispatchTags from "../../utils/DispatchTags";

export default {
  name: "HeaderDefault",
  components: {Modal},
  computed:{
    titulo:function (){
      if(this.loadingStatus){
        return "Confirmar identidade";
      }
      return this.$store.state.titulo;
    },
    loadingStatus() {
      return this.$store.getters.loadingStatus
    }
  },
  methods:{
    btnFechar:function (){
      if(this.$route.name === 'TermoUso'){
        this.$router.replace({name: 'ConfirmarIdentidade'});
      }else{
        DispatchTags.dispatchNoninteraction('HeaderDefault');
        $('#modalfechar').modal()
      }
    },
    sairDoApp:function (){
      DispatchTags.dispatchInraction('HeaderDefaultConfirm');
      sessionStorage.clear();
      this.$store.dispatch('resetState');
      window.close();
      window.setTimeout(()  => window.open("about:blank", "_self"),400);
    },
    fecharModal:function (){
      DispatchTags.dispatchInraction('HeaderDefaultExit');
    }
  }
}
</script>

<style scoped>
  .container-header{
    height: 3.5rem;
    padding-top: 1rem;
    margin-bottom: 1.25rem;
    padding-left: 0;
  }
  .container-header p{
    font-family: 'VivoType', Sans-Serif;
    color: var(--text-text-secondary, #666);
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
  .btn-fechar{
    float: left;
    position: relative;
    font-size: 1.125rem;
    color: var(--text-text-primary, #000);
  }

  @media (max-height: 550px) {
    .container-header{
      height: 3rem;
      padding-top: 0.8rem;
      margin-bottom: 0.8rem;
    }
  }
</style>
<style>
#modalfechar{
  transform: translateY(25%);
}
#modalfechar .modal-header{
  padding-bottom: 0;
  margin-bottom: 0;
  border: none;
}
#modalfechar .modal-body{
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 2rem;
}
#modalfechar .modal-footer{
  padding-top: 0;
  margin-top: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderDefault.vue